import React from "react";
import Navbar from "../Manager/Routes/Navbar";
import { Navigate } from "react-router-dom";
import { getUser } from "../../Utils/helper";
import DashboardContentShell from "./DashboardContentShell";

const ManagerLayout = () => {
  let userAuth = getUser() ? getUser() || "" : null;
  return userAuth?.employee?.role === "manager" ? (
    <React.Fragment>
      <Navbar />
      <DashboardContentShell />
    </React.Fragment>
  ) : (
    <Navigate to={`/`} />
  );
};
export default ManagerLayout;
